"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switcher = exports.SIZES = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./style.scss");
// define sizes using TypeScript enum
var SIZES;
(function (SIZES) {
    SIZES["DEFAULT"] = "DEFAULT";
    SIZES["COMPACT"] = "COMPACT";
})(SIZES || (exports.SIZES = SIZES = {}));
// functional component with TypeScript
const Switcher = ({ options, onSelect, value, disabled = false, size = SIZES.DEFAULT, label, }) => (react_1.default.createElement("div", null,
    label && react_1.default.createElement("div", { className: 'switcher-label' }, label),
    react_1.default.createElement("div", { className: (0, classnames_1.default)('switcher', size?.toLowerCase(), { disabled }) }, options.map((option) => (react_1.default.createElement(react_1.Fragment, { key: option.value.toString() },
        react_1.default.createElement("div", { onClick: () => !disabled && !option.disabled && onSelect(option.value), className: (0, classnames_1.default)('switcher-btn', {
                active: option.value === value,
                disabled: option.disabled,
            }) }, option.label),
        react_1.default.createElement("div", { className: 'separator' })))))));
exports.Switcher = Switcher;
// explicitly attach SIZES to Switcher
Switcher.SIZES = SIZES;
